import { useAppSelector } from '@store/hooks/redux';
import { IState } from '@store/reducers/ratings';
import { getRatingsList } from '@store/selectors/ratings';

export const useRatingsList = (): IState['list'] => useAppSelector(getRatingsList);
